export default __webpack_public_path__ + "static/featured-image_case-min-c924fcf86ccdc331286fc78c16e6c79c.jpg";